<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { cardKey, cardMethodsKey } from "@/components/StickyNote/injectKeys";
import { actionSourceKey } from "@/components/action/injectKeys";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { Team } from "@/model/session";
import { injectStrict } from "@/utils/vue";

import TeamSelector from "../TeamSelector/TeamSelector.vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);
const cardMethods = injectStrict(cardMethodsKey);
const actionSource = injectStrict(actionSourceKey);

const handleChangeEnabling = (team: Team | null) => {
  cardActions.setDepend(actionSource, card.id, team);
  if (team?.id) {
    void cardMethods.animate?.("mirroring");
  }
  dropdown.close();
};
</script>

<template>
  <TeamSelector
    show-other-arts
    show-external
    :title="$t('actionMenu.enabling')"
    @select="handleChangeEnabling"
  />
</template>
